import _ from 'lodash'
import React, { Component } from 'react'
import { clearFields } from 'redux-form'
import { connect } from 'react-redux'

import { listDefects, getPdf } from '../actions/defect'
import { clearDefectAreaKey, listDefectAreas } from '../actions/defect-area'
import { clearMainAreaKey, listMainAreas } from '../actions/main-area'
import { clearProjectKey, listProjects } from '../actions/project'
import { clearUserKey, listUsers, setUserIsLoading, setUserSelected } from '../actions/user'

import DefectList from '../components/DefectList'

class DefectPage extends Component {
  componentDidMount () {
    const {
      listDefects, clearProjectKey, listProjects, clearMainAreaKey, clearDefectAreaKey, clearUserKey
    } = this.props
    listDefects()
    clearProjectKey()
    listProjects({ limit: -1 })
    clearMainAreaKey()
    clearDefectAreaKey()
    clearUserKey()
  }

  render () {
    return (<DefectList {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  query: _.get(state, 'defect.query'),
  order: _.get(state, 'defect.query.order'),
  list: _.get(state, 'defect.list'),
  projects: _.get(state, 'project.project.list.rows', []),
  mainAreas: _.get(state, 'mainArea.mainArea.list.rows', []),
  defectAreas: _.get(state, 'defectArea.defectArea.list.rows', []),
  assignee: _.get(state, 'user.assignee ', { isLoading: false, list: { rows: [] }, selected: [], defaultSelected: [] }),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  listDefects (query = {}, assignee, order) {
    query = assignee ? _.merge(query, { assigneeId: assignee.id }) : _.omit(query, 'assigneeId')
    if (order) {
      let newOrder = `${order},DESC`
      if (query.order) {
        const orders = query.order.split(',')
        if (orders[0] === order) {
          newOrder = orders[1] === 'DESC' ? `${order},ASC` : `${order},DESC`
        }
      }
      query.order = newOrder
    }
    dispatch(listDefects(query))
  },
	getPdf (query = {}, assignee, order) {
		query = assignee ? _.merge(query, { assigneeId: assignee.id }) : _.omit(query, 'assigneeId')
		if (order) {
			let newOrder = `${order},DESC`
			if (query.order) {
				const orders = query.order.split(',')
				if (orders[0] === order) {
					newOrder = orders[1] === 'DESC' ? `${order},ASC` : `${order},DESC`
				}
			}
			query.order = newOrder
		}
		dispatch(getPdf(query))
	},
  listProjects (query) {
    dispatch(listProjects(query, 'project'))
  },
  async onProjectChanged (event, projectId) {
    await dispatch(listMainAreas({ projectId, limit: -1 }, 'mainArea'))
    dispatch(clearFields('defect-list', false, false, 'mainAreaId', 'defectAreaId'))
  },
  clearProjectKey () {
    dispatch(clearProjectKey('project'))
  },
  async onMainAreaChanged (event, mainAreaId) {
    await dispatch(listDefectAreas({ mainAreaId, limit: -1 }, 'defectArea'))
    dispatch(clearFields('defect-list', false, false, 'defectAreaId'))
  },
  clearMainAreaKey () {
    dispatch(clearMainAreaKey('mainArea'))
  },
  clearDefectAreaKey () {
    dispatch(clearDefectAreaKey('defectArea'))
  },
  async searchUser (name) {
    dispatch(setUserIsLoading(true, 'assignee'))
    await dispatch(listUsers({ name }, 'assignee'))
    dispatch(setUserIsLoading(false, 'assignee'))
  },
  setUserSelected (selected) {
    dispatch(setUserSelected(selected, 'assignee'))
  },
  clearUserKey () {
    dispatch(clearUserKey('assignee'))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DefectPage)



// WEBPACK FOOTER //
// ./src/containers/DefectPage.js